// extracted by css-extract-rspack-plugin
export default {"item":"g9syb"};